

























import Vue from "vue";
import AlertComp from "../components/homepage/AlertComp.vue";
import EinladungenComp from "../components/homepage/EinladungenComp.vue";
import HomepageTermineComp from "../components/homepage/HomepageTermineComp.vue";
import ProgressOverviewComp from "../components/profile/ProgressOverviewComp.vue";
import _users from "../services/endpoints/users";
import { Spieler } from "models/Spieler";

export default Vue.extend({
	name: "HomePage",
	components: { ProgressOverviewComp, HomepageTermineComp, EinladungenComp, AlertComp },
	data: () => ({
		hasNoApi: false,
	}),
	computed: {
		user: function(): Spieler {
			return this.$vStore.getters.loggedInUser;
		},
	},
	created: async function(): Promise<void> {
		this.hasNoApi = !(await _users.hasApi());
	},
});
